import { LOGUS_CONFIG } from '../config'
import axios from 'axios'

export default {

    /*
        GET     /api/courses
    */
    getCourses: function(options){
        return axios.get( LOGUS_CONFIG.API_URL + '/courses',{
            params:{
                offset:options.offset,
                itemsPerPage:options.itemsPerPage,
                orderBy:options.orderBy,
                orderDirection:options.orderDirection,
                showDeleted:options.showDeleted,
                selectedYear:options.selectedYear
        }});
    },

     /*
        GET     /api/courses/my
    */
   getMyCourses: function(options){
    return axios.get( LOGUS_CONFIG.API_URL + '/courses/my',{
        params:{
            offset:options.offset,
            itemsPerPage:options.itemsPerPage,
            orderBy:options.orderBy,
            orderDirection:options.orderDirection,
            showDeleted:options.showDeleted,
            selectedYear:options.selectedYear
    }});
},

 /*
        GET     /api/courses/temp
    */
    getTempCourses: function(options){
        return axios.get( LOGUS_CONFIG.API_URL + '/courses/temp');
    },

    /*
        GET     /api/courses/search
    */
   searchCourses: function(options){
    return axios.get( LOGUS_CONFIG.API_URL + '/courses/search',{
        params:{
            showDeleted:options.showDeleted,
            selectedYear:options.selectedYear,
            filterableHeaders:options.filterableHeaders,
            q:options.q
    }});
},

    /*
		POST 	/api/courses
	*/
    postAddNewCourse: function( name,year_id, department_id,room,from,to ){
        return axios.post( LOGUS_CONFIG.API_URL + '/courses',
            {
                name: name,
                year_id:year_id,
                department_id:department_id,
                room:room,
                from:from,
                to:to,
            }
        );
    },

     /*
		POST 	/api/courses/temp
	*/
    postAddNewTempCourse: function( user_id,course_id, valid){
        return axios.post( LOGUS_CONFIG.API_URL + '/courses/temp',
            {
                user_id: user_id,
                course_id:course_id,
                valid:valid,
            }
        );
    },

      /*
		POST 	/api/courses/copy
	*/
    postCopyCourses: function( source,destination, users){
        return axios.post( LOGUS_CONFIG.API_URL + '/courses/copy',
            {
                source: source,
                destination:destination,
                users:users,
            }
        );
    },

    /*
		GET 	/api/courses/{slug}/edit
	*/
    getCourseEdit: function( slug ){
		return axios.get( LOGUS_CONFIG.API_URL + '/courses/' + slug + '/edit' );
    },
    
    

    /*
		PUT 	/api/courses/{slug}
	*/
    putEditCourse: function(slug, name,year_id, department_id,room,from,to ){
        return axios.put( LOGUS_CONFIG.API_URL + '/courses/'+ slug,
            {
                name: name,
                year_id:year_id,
                department_id:department_id,
                room:room,
                from:from,
                to:to,
            }
        );
    },

    /*
		PUT 	/api/courses/prolong/{slug}
	*/
    putProlongTempCourse: function(slug, duration){
        return axios.put( LOGUS_CONFIG.API_URL + '/courses/prolong/'+ slug,
            {
                duration: duration
            }
        );
    },

     /*
		GET 	/api/courses/reactivate/{slug}
	*/
    putReactivateCourse: function(slug){
        return axios.get( LOGUS_CONFIG.API_URL + '/courses/reactivate/' + slug);
    },

    /*
		DELETE /api/courses/{slug}
	*/
    deleteCourse: function( slug ){
		return axios.delete( LOGUS_CONFIG.API_URL + '/courses/' + slug );
    },
    
    /*
		DELETE /api/courses/{slug}/force
	*/
    forceDeleteCourse: function( slug ){
		return axios.delete( LOGUS_CONFIG.API_URL + '/courses/' + slug + '/force' );
    },
    
    //#######################################
     /*
		GET 	/api/courses/{slug}
	*/
    getCourse: function( slug ){
		return axios.get( LOGUS_CONFIG.API_URL + '/courses/' + slug );
    },
    
    /*
		PUT 	/api/courses/{slug}/addUser/{id}
	*/
    putAddUser: function(slug, id ){
        return axios.put( LOGUS_CONFIG.API_URL + '/courses/'+ slug + '/addUser/' + id);
    },

     /*
		PUT 	/api/courses/{slug}/addTempUser/{id}
	*/
    putAddTempUser: function(slug, id ){
        return axios.put( LOGUS_CONFIG.API_URL + '/courses/'+ slug + '/addTempUser/' + id);
    },

    /*
		PUT 	/api/courses/{slug}/deleteUser/{id}
	*/
    putDeleteUser: function(slug, id ){
        return axios.put( LOGUS_CONFIG.API_URL + '/courses/'+ slug + '/deleteUser/' + id);
    },

    /*
		PUT 	/api/courses/{slug}/deleteChildren
	*/
    putDeleteChildren: function(slug, ids ){
        return axios.put( LOGUS_CONFIG.API_URL + '/courses/'+ slug + '/deleteChildren',{
            ids:ids
        });
    },

    /*
		PUT 	/api/courses/{slug}/addChildren
	*/
    putAddChildren: function(slug, ids ){
        return axios.put( LOGUS_CONFIG.API_URL + '/courses/'+ slug + '/addChildren',{
            ids:ids
        });
    },

}